import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const isElectron =
  typeof window !== 'undefined' && window.electronAPI?.isElectron === true;

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator && !isElectron) {
  window.addEventListener('load', () => {
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    const swUrl = `${base}/service-worker.js`;
    navigator.serviceWorker.register(swUrl).catch(() => {});
  });
}